import React, { useEffect, useState } from "react"
import theme from "theme"
import { Theme, Box, Section, Text, Span, Image } from "@quarkly/widgets"
import { GlobalQuarklyPageStyles } from "global-page-styles"
import { Override } from "@quarkly/components"
import * as Components from "components"
import translations from "../translations"

const IndexPage = () => {
  const heroImages = [
    "/images/hero_spa_0.png",
    "/images/hero_spa_1.png",
    "/images/hero_spa_2.png",
    "/images/hero_spa_3.png",
    "/images/hero_spa_4.png",
    "/images/hero_spa_5.png",
    "/images/hero_spa_6.png",
    "/images/hero_spa_7.png",
    "/images/hero_spa_8.png",
    "/images/hero_spa_9.png",
    "/images/hero_spa_10.png",
    "/images/hero_spa_11.png",
    "/images/hero_spa_12.png",
  ]
  const [heroImage, setHeroImage] = useState(heroImages[0])
  const [lang, setLang] = useState("en")

  useEffect(() => {
    setHeroImage(heroImages[Math.floor(Math.random() * heroImages.length)])
    // Simple opacity fade on scroll — no transforms, no clip-path
    var elements = document.querySelectorAll(
      '[quarkly-title="Embodied Attention Explainer"],' +
        '[quarkly-title="Architecture Consulting Services"],' +
        '[quarkly-title="Services"],' +
        '[quarkly-title="Sectors"],' +
        'section[id="team"],' +
        '[quarkly-title="Steps"]'
    )

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1"
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach(function (el) {
      el.style.opacity = "0"
      el.style.transition = "opacity 0.8s ease"
      observer.observe(el)
    })

    // LocalStorage language recovery
    const savedLang = localStorage.getItem("lang")
    if (savedLang) {
      setLang(savedLang)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSetLang = newLang => {
    setLang(newLang)
    localStorage.setItem("lang", newLang)
  }

  const t = translations[lang]

  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.SEO title={t.seoTitle} description={t.seoDesc} pathname="/" />
      <Components.Header lang={lang} setLang={handleSetLang} />
      <Section
        padding="0"
        quarkly-title="HeroBlock"
        background="--color-light"
        display="flex"
        flex-direction="column"
      >
        <Override
          slot="SectionContent"
          max-width="none"
          width="100%"
          padding="0"
        />
        <Image
          src={heroImage}
          width="100%"
          height="70vh"
          object-fit="cover"
          margin="0"
          border-radius="0"
        />
        <Box
          padding="60px 60px 80px 60px"
          sm-padding="40px 20px 60px 20px"
          display="flex"
          flex-direction="column"
          max-width="900px"
        >
          <Text
            color="--grey"
            font="normal 500 13px/2 --fontFamily-googleInter"
            letter-spacing="5px"
            text-transform="uppercase"
            margin="0 0 20px 0"
          >
            {t.hero.category}
          </Text>
          <Text
            color="--dark"
            font="normal 600 64px/1.1 --fontFamily-googlePoppins"
            margin="0 0 32px 0"
            sm-font="normal 600 32px/1.15 --fontFamily-googlePoppins"
            lg-font="normal 600 48px/1.1 --fontFamily-googlePoppins"
          >
            {lang === "en" ? (
              <>
                Spaces that{" "}
                <Span font-style="italic" font-weight="400">
                  engage
                </Span>
                <br />
                the body, not just the eye
              </>
            ) : (
              t.hero.slogan
            )}
          </Text>
          <Box
            width="40px"
            height="2px"
            background="--color-dark"
            margin="0 0 24px 0"
          />
          <Text
            color="--darkL2"
            font="normal 300 18px/1.8 --fontFamily-googleInter"
            margin="0"
            max-width="560px"
          >
            {t.hero.description}
          </Text>
        </Box>
      </Section>
      <Section
        id="approach"
        padding="140px 60px"
        background="--color-light"
        quarkly-title="Embodied Attention Explainer"
        sm-padding="100px 20px 60px 20px"
      >
        <Override
          slot="SectionContent"
          max-width="1400px"
          flex-direction="row"
          align-items="stretch"
          grid-gap="100px"
          md-flex-direction="column"
          sm-flex-direction="column"
        />
        <Box
          width="55%"
          md-width="100%"
          sm-width="100%"
          display="flex"
          flex-direction="column"
          justify-content="center"
        >
          <Text
            color="--darkL2"
            font="normal 600 12px/1.5 --fontFamily-googleInter"
            letter-spacing="4px"
            text-transform="uppercase"
            margin="0 0 24px 0"
          >
            {t.approach.category}
          </Text>
          <Text
            color="--dark"
            font="normal 300 48px/1.15 --fontFamily-googlePoppins"
            margin="0 0 40px 0"
            lg-font="normal 300 36px/1.2 --fontFamily-googlePoppins"
          >
            {lang === "en" ? (
              <>
                What is Embodied
                <br />
                Attention?
              </>
            ) : (
              t.approach.title
            )}
          </Text>
          <Text
            color="--darkL2"
            font="normal 300 16px/1.8 --fontFamily-googleInter"
            margin="0 0 24px 0"
          >
            {t.approach.p1}
          </Text>
          <Text
            color="--darkL2"
            font="normal 300 16px/1.8 --fontFamily-googleInter"
            margin={t.approach.p3 ? "0 0 24px 0" : "0"}
          >
            {t.approach.p2}
          </Text>
          {t.approach.p3 && (
            <Text
              color="--darkL2"
              font="normal 300 16px/1.8 --fontFamily-googleInter"
              margin="0"
            >
              {t.approach.p3}
            </Text>
          )}
        </Box>
        <Box width="45%" md-width="100%" sm-width="100%" position="relative">
          <Image
            src="/images/embodied_attention.png"
            height="100%"
            object-fit="cover"
            width="100%"
            border-radius="2px"
          />
        </Box>
      </Section>
      <Section
        padding="160px 60px"
        background="--color-lightD1"
        quarkly-title="Architecture Consulting Services"
        sm-padding="100px 20px 60px 20px"
      >
        <Override
          slot="SectionContent"
          max-width="1400px"
          flex-direction="row"
          align-items="stretch"
          grid-gap="100px"
          md-flex-direction="column"
          sm-flex-direction="column"
        />
        <Box
          width="45%"
          md-width="100%"
          sm-width="100%"
          display="flex"
          flex-direction="column"
          justify-content="center"
        >
          <Text
            color="--darkL2"
            font="normal 600 12px/1.5 --fontFamily-googleInter"
            letter-spacing="4px"
            text-transform="uppercase"
            margin="0 0 24px 0"
          >
            {t.studio.category}
          </Text>
          <Text
            color="--dark"
            font="normal 300 48px/1.15 --fontFamily-googlePoppins"
            margin="0 0 40px 0"
            lg-font="normal 300 36px/1.2 --fontFamily-googlePoppins"
          >
            {lang === "en" ? (
              <>
                Research-Driven
                <br />
                Spatial Design.
              </>
            ) : (
              t.studio.title
            )}
          </Text>
          <Text
            color="--darkL2"
            font="normal 300 16px/1.8 --fontFamily-googleInter"
            margin="0 0 24px 0"
          >
            {t.studio.p1}
          </Text>
          <Text
            color="--darkL2"
            font="normal 300 16px/1.8 --fontFamily-googleInter"
            margin="0"
          >
            {t.studio.p2}
          </Text>
        </Box>
        <Box width="55%" md-width="100%" sm-width="100%" position="relative">
          <Image
            src="/images/research_design.png"
            height="100%"
            object-fit="cover"
            width="100%"
            border-radius="2px"
          />
        </Box>
      </Section>
      <Section
        id="services"
        padding="140px 60px"
        background="--color-light"
        quarkly-title="Services"
        sm-padding="100px 20px 60px 20px"
        border-top="1px solid #EEEEEE"
      >
        <Override
          slot="SectionContent"
          max-width="1200px"
          flex-direction="column"
          align-items="flex-start"
          grid-gap="80px"
        />
        <Box
          display="flex"
          flex-direction="row"
          align-items="flex-end"
          grid-gap="40px"
          md-flex-direction="column"
          sm-flex-direction="column"
          width="100%"
        >
          <Text
            color="--dark"
            font="normal 600 48px/1.15 --fontFamily-googlePoppins"
            margin="0"
            lg-font="normal 600 36px/1.2 --fontFamily-googlePoppins"
          >
            {t.services.title}
          </Text>
          <Box
            width="40px"
            height="2px"
            background="--color-dark"
            margin="0 0 12px 0"
            sm-width="100%"
          />
        </Box>
        <Box display="flex" flex-direction="column" width="100%" grid-gap="0px">
          {t.services.list.map((item, index) => (
            <Box
              key={index}
              display="flex"
              flex-direction="row"
              padding="40px 0"
              border-top="1px solid #EEEEEE"
              border-bottom={
                index === t.services.list.length - 1
                  ? "1px solid #EEEEEE"
                  : "none"
              }
              grid-gap="40px"
              md-flex-direction="column"
              sm-flex-direction="column"
              align-items="flex-start"
            >
              <Text
                color="#CCCCCC"
                font="normal 200 72px/1 --fontFamily-googlePoppins"
                margin="0"
                min-width="100px"
              >
                {item.num}
              </Text>
              <Box>
                <Text
                  color="--dark"
                  font="normal 500 24px/1.3 --fontFamily-googlePoppins"
                  margin="0 0 12px 0"
                >
                  {item.title}
                </Text>
                <Text
                  color="--darkL2"
                  font="normal 300 16px/1.8 --fontFamily-googleInter"
                  margin="0"
                  max-width="800px"
                >
                  {item.desc}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>
      </Section>
      <Section
        id="sectors"
        padding="140px 60px"
        background="--color-light"
        quarkly-title="Sectors"
        sm-padding="100px 20px 60px 20px"
      >
        <Override
          slot="SectionContent"
          max-width="1400px"
          flex-direction="row"
          md-flex-direction="column"
          sm-flex-direction="column"
          align-items="stretch"
          grid-gap="100px"
        />
        <Box width="50%" md-width="100%" sm-width="100%">
          <Image
            src="/images/premium_spaces.png"
            height="100%"
            object-fit="cover"
            width="100%"
            border-radius="2px"
          />
        </Box>
        <Box
          width="50%"
          md-width="100%"
          sm-width="100%"
          display="flex"
          flex-direction="column"
          justify-content="center"
        >
          <Text
            color="--darkL2"
            font="normal 600 12px/1.5 --fontFamily-googleInter"
            letter-spacing="4px"
            text-transform="uppercase"
            margin="0 0 24px 0"
          >
            {t.sectors.category}
          </Text>
          <Text
            color="--dark"
            font="normal 300 48px/1.15 --fontFamily-googlePoppins"
            margin="0 0 50px 0"
            lg-font="normal 300 36px/1.2 --fontFamily-googlePoppins"
          >
            {t.sectors.title}
          </Text>
          <Box display="flex" flex-direction="column" grid-gap="32px">
            <Box
              display="flex"
              flex-direction="column"
              border-top="1px solid rgba(10, 25, 47, 0.08)"
              padding="24px 0 0 0"
            >
              <Text
                color="--dark"
                font="normal 400 20px/1.4 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                {t.sectors.residentialDev.title}
              </Text>
              <Text
                color="--grey"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
              >
                {t.sectors.residentialDev.desc}
              </Text>
            </Box>
            <Box
              display="flex"
              flex-direction="column"
              border-top="1px solid rgba(10, 25, 47, 0.08)"
              padding="24px 0 0 0"
            >
              <Text
                color="--dark"
                font="normal 400 20px/1.4 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                {t.sectors.apartmentDev.title}
              </Text>
              <Text
                color="--grey"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
              >
                {t.sectors.apartmentDev.desc}
              </Text>
            </Box>
            <Box
              display="flex"
              flex-direction="column"
              border-top="1px solid rgba(10, 25, 47, 0.08)"
              padding="24px 0 0 0"
            >
              <Text
                color="--dark"
                font="normal 400 20px/1.4 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                {t.sectors.privateEstate.title}
              </Text>
              <Text
                color="--grey"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
              >
                {t.sectors.privateEstate.desc}
              </Text>
            </Box>
          </Box>
        </Box>
      </Section>
      <Section
        id="team"
        padding="140px 60px"
        background="--color-light"
        sm-padding="100px 20px 60px 20px"
        border-top="1px solid #EEEEEE"
      >
        <Override
          slot="SectionContent"
          max-width="1200px"
          flex-direction="column"
          align-items="flex-start"
          grid-gap="80px"
        />
        <Box
          display="flex"
          flex-direction="column"
          grid-gap="16px"
          width="100%"
        >
          <Text
            color="--grey"
            font="normal 500 13px/2 --fontFamily-googleInter"
            letter-spacing="5px"
            text-transform="uppercase"
            margin="0"
          >
            {t.team.category}
          </Text>
          <Text
            color="--dark"
            font="normal 600 48px/1.15 --fontFamily-googlePoppins"
            margin="0"
            lg-font="normal 600 36px/1.2 --fontFamily-googlePoppins"
          >
            {t.team.title}
          </Text>
          <Box width="40px" height="2px" background="--color-dark" margin="0" />
        </Box>
        <Box
          display="flex"
          flex-direction="row"
          grid-gap="60px"
          width="100%"
          md-flex-direction="column"
          sm-flex-direction="column"
        >
          <Box
            width="50%"
            md-width="100%"
            sm-width="100%"
            display="flex"
            flex-direction="column"
          >
            <Box overflow-x="hidden" overflow-y="hidden" margin="0 0 32px 0">
              <Image
                src="/team/erina.png"
                width="100%"
                height="400px"
                object-fit="cover"
                border-radius="0"
              />
            </Box>
            <Text
              font="normal 600 24px/1.2 --fontFamily-googlePoppins"
              color="--dark"
              margin="0 0 4px 0"
            >
              {t.team.erina.name}
            </Text>
            <Text
              font="normal 300 15px/1.6 --fontFamily-googleInter"
              color="--grey"
              margin="0 0 28px 0"
            >
              {t.team.erina.title}
            </Text>

            <Text
              font="normal 600 11px/1.5 --fontFamily-googleInter"
              color="--dark"
              margin="0 0 10px 0"
              letter-spacing="2px"
              text-transform="uppercase"
            >
              {t.team.education}
            </Text>
            {t.team.erina.edu.map((item, idx) => (
              <Text
                key={idx}
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                color="--darkL2"
                margin={
                  idx === t.team.erina.edu.length - 1
                    ? "0 0 24px 0"
                    : "0 0 4px 0"
                }
              >
                {item}
              </Text>
            ))}

            <Text
              font="normal 600 11px/1.5 --fontFamily-googleInter"
              color="--dark"
              margin="0 0 10px 0"
              letter-spacing="2px"
              text-transform="uppercase"
            >
              {t.team.experience}
            </Text>
            {t.team.erina.exp.map((item, idx) => (
              <Text
                key={idx}
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                color="--darkL2"
                margin={
                  idx === t.team.erina.exp.length - 1
                    ? "0 0 24px 0"
                    : "0 0 4px 0"
                }
              >
                {item}
              </Text>
            ))}

            <Text
              font="normal 600 11px/1.5 --fontFamily-googleInter"
              color="--dark"
              margin="0 0 10px 0"
              letter-spacing="2px"
              text-transform="uppercase"
            >
              {t.team.awards}
            </Text>
            {t.team.erina.awards.map((item, idx) => (
              <Text
                key={idx}
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                color="--darkL2"
                margin={
                  idx === t.team.erina.awards.length - 1 ? "0" : "0 0 4px 0"
                }
              >
                {item}
              </Text>
            ))}
          </Box>
          <Box
            width="50%"
            md-width="100%"
            sm-width="100%"
            display="flex"
            flex-direction="column"
          >
            <Box overflow-x="hidden" overflow-y="hidden" margin="0 0 32px 0">
              <Image
                src="/team/susana.png"
                width="100%"
                height="400px"
                object-fit="cover"
                border-radius="0"
              />
            </Box>
            <Text
              font="normal 600 24px/1.2 --fontFamily-googlePoppins"
              color="--dark"
              margin="0 0 4px 0"
            >
              {t.team.susana.name}
            </Text>
            <Text
              font="normal 300 15px/1.6 --fontFamily-googleInter"
              color="--grey"
              margin="0 0 28px 0"
            >
              {t.team.susana.title}
            </Text>

            <Text
              font="normal 600 11px/1.5 --fontFamily-googleInter"
              color="--dark"
              margin="0 0 10px 0"
              letter-spacing="2px"
              text-transform="uppercase"
            >
              {t.team.education}
            </Text>
            {t.team.susana.edu.map((item, idx) => (
              <Text
                key={idx}
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                color="--darkL2"
                margin={
                  idx === t.team.susana.edu.length - 1
                    ? "0 0 24px 0"
                    : "0 0 4px 0"
                }
              >
                {item}
              </Text>
            ))}

            <Text
              font="normal 600 11px/1.5 --fontFamily-googleInter"
              color="--dark"
              margin="0 0 10px 0"
              letter-spacing="2px"
              text-transform="uppercase"
            >
              {t.team.experience}
            </Text>
            {t.team.susana.exp.map((item, idx) => (
              <Text
                key={idx}
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                color="--darkL2"
                margin={
                  idx === t.team.susana.exp.length - 1
                    ? "0 0 24px 0"
                    : "0 0 4px 0"
                }
              >
                {item}
              </Text>
            ))}

            <Text
              font="normal 600 11px/1.5 --fontFamily-googleInter"
              color="--dark"
              margin="0 0 10px 0"
              letter-spacing="2px"
              text-transform="uppercase"
            >
              {t.team.grants}
            </Text>
            {t.team.susana.awards.map((item, idx) => (
              <Text
                key={idx}
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                color="--darkL2"
                margin={
                  idx === t.team.susana.awards.length - 1 ? "0" : "0 0 4px 0"
                }
              >
                {item}
              </Text>
            ))}
          </Box>
        </Box>
      </Section>
      <Section
        padding="100px 40px 100px 40px"
        background="--color-light"
        sm-padding="40px 20px 40px 20px"
      >
        <Override
          slot="SectionContent"
          width="100%"
          max-width="none"
          sm-min-width="280px"
          display="flex"
          flex-direction="row"
          flex-wrap="no-wrap"
          grid-column-gap="50px"
          sm-display="flex"
          sm-flex-direction="column"
          sm-flex-wrap="no-wrap"
          sm-grid-row-gap="30px"
          md-display="flex"
          md-flex-direction="column"
          md-flex-wrap="no-wrap"
          md-grid-row-gap="30px"
          justify-content="center"
          md-grid-row-gap="30px"
        />
        <Image
          width="40%"
          md-width="100%"
          lg-width="60%"
          md-background="rgba(0, 0, 0, 0) url() 50% 50% /cover repeat scroll padding-box"
          src="https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000"
          srcSet="https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=500 500w,https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=800 800w,https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1080 1080w,https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1600 1600w,https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2000 2000w,https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2600 2600w,https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=3200 3200w"
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 1240px) 100vw,100vw"
        />
        <Box
          min-width="100px"
          min-height="100px"
          display="flex"
          flex-direction="column"
          flex-wrap="no-wrap"
          grid-row-gap="40px"
          sm-display="flex"
          sm-grid-row-gap="20px"
          sm-overflow="visible"
          width="30%"
          md-display="flex"
          md-grid-row-gap="100%"
          md-width="100%"
          justify-content="flex-start"
          align-items="flex-start"
        >
          <Text
            color="--dark"
            margin="0px 0px 0px 0px"
            font="normal 600 48px/1.15 --fontFamily-googlePoppins"
            text-align="left"
            lg-width="100%"
            lg-font="normal 600 36px/1.2 --fontFamily-googlePoppins"
          >
            {t.contact.title}
          </Text>
          <Text
            color="--darkL2"
            margin="20px 0px 0px 0px"
            font="normal 300 16px/1.8 --fontFamily-googleInter"
            lg-width="100%"
            lg-max-width="540px"
            width="auto"
          >
            {t.contact.p1}
            {t.contact.p2 && (
              <>
                <br />
                <br />
                {t.contact.p2}
              </>
            )}
            {t.contact.p3 && (
              <>
                <br />
                <br />
                {t.contact.p3}
              </>
            )}
          </Text>
        </Box>
      </Section>
      <Section
        padding="120px 60px"
        background="--color-light"
        sm-padding="100px 20px 60px 20px"
        quarkly-title="Steps"
        border-top="1px solid #EEEEEE"
        display="none"
      >
        <Override
          slot="SectionContent"
          max-width="1200px"
          flex-direction="column"
          align-items="flex-start"
          grid-gap="60px"
        />
        <Box
          display="flex"
          flex-direction="row"
          align-items="flex-end"
          grid-gap="40px"
          md-flex-direction="column"
          sm-flex-direction="column"
          width="100%"
        >
          <Text
            color="--dark"
            font="normal 600 48px/1.15 --fontFamily-googlePoppins"
            margin="0"
            lg-font="normal 600 36px/1.2 --fontFamily-googlePoppins"
          >
            How It Works
          </Text>
          <Box
            width="40px"
            height="2px"
            background="--color-dark"
            margin="0 0 12px 0"
            sm-width="100%"
          />
        </Box>
        <Box display="flex" flex-direction="column" width="100%" grid-gap="0px">
          <Box
            display="flex"
            flex-direction="row"
            padding="36px 0"
            border-top="1px solid #EEEEEE"
            grid-gap="40px"
            md-flex-direction="column"
            sm-flex-direction="column"
            align-items="flex-start"
          >
            <Text
              color="#CCCCCC"
              font="normal 200 72px/1 --fontFamily-googlePoppins"
              margin="0"
              min-width="100px"
            >
              01
            </Text>
            <Box>
              <Text
                color="--dark"
                font="normal 500 24px/1.3 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                Describe Your Project
              </Text>
              <Text
                color="--darkL2"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
                max-width="600px"
              >
                Tell us about your space, your goals, and the experience you
                want to create. No commitment — we'll assess whether embodied
                attention design is the right approach.
              </Text>
            </Box>
          </Box>
          <Box
            display="flex"
            flex-direction="row"
            padding="36px 0"
            border-top="1px solid #EEEEEE"
            grid-gap="40px"
            md-flex-direction="column"
            sm-flex-direction="column"
            align-items="flex-start"
          >
            <Text
              color="#CCCCCC"
              font="normal 200 72px/1 --fontFamily-googlePoppins"
              margin="0"
              min-width="100px"
            >
              02
            </Text>
            <Box>
              <Text
                color="--dark"
                font="normal 500 24px/1.3 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                Receive an Assessment
              </Text>
              <Text
                color="--darkL2"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
                max-width="600px"
              >
                Our team reviews your project and provides an initial embodied
                attention analysis with clear next steps and a tailored scope of
                work.
              </Text>
            </Box>
          </Box>
          <Box
            display="flex"
            flex-direction="row"
            padding="36px 0"
            border-top="1px solid #EEEEEE"
            grid-gap="40px"
            md-flex-direction="column"
            sm-flex-direction="column"
            align-items="flex-start"
          >
            <Text
              color="#CCCCCC"
              font="normal 200 72px/1 --fontFamily-googlePoppins"
              margin="0"
              min-width="100px"
            >
              03
            </Text>
            <Box>
              <Text
                color="--dark"
                font="normal 500 24px/1.3 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                Review & Approve
              </Text>
              <Text
                color="--darkL2"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
                max-width="600px"
              >
                We present a detailed proposal with transparent pricing. Work
                begins only after your approval.
              </Text>
            </Box>
          </Box>
          <Box
            display="flex"
            flex-direction="row"
            padding="36px 0"
            border-top="1px solid #EEEEEE"
            border-bottom="1px solid #EEEEEE"
            grid-gap="40px"
            md-flex-direction="column"
            sm-flex-direction="column"
            align-items="flex-start"
          >
            <Text
              color="#CCCCCC"
              font="normal 200 72px/1 --fontFamily-googlePoppins"
              margin="0"
              min-width="100px"
            >
              04
            </Text>
            <Box>
              <Text
                color="--dark"
                font="normal 500 24px/1.3 --fontFamily-googlePoppins"
                margin="0 0 8px 0"
              >
                Experience the Difference
              </Text>
              <Text
                color="--darkL2"
                font="normal 300 16px/1.8 --fontFamily-googleInter"
                margin="0"
                max-width="600px"
              >
                From research through implementation, we guide the process to
                deliver a space that engages the body, not just the eye.
              </Text>
            </Box>
          </Box>
        </Box>
      </Section>
      <Section
        align-items="center"
        display="flex"
        background="--color-light"
        border-top="1px solid #EEEEEE"
      >
        <Override slot="SectionContent" align-items="center" />
        <Components.MainForm height="100vh" width="100%" display="flex" />
      </Section>
      <Components.Footer />

      <Components.ScrollToTop />
      <Components.CookieBanner />
    </Theme>
  )
}

export default IndexPage
